import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker as MaterialDateTimePicker } from '@material-ui/pickers';

const DateTimePicker = (props) => {
    return (
        <MaterialDateTimePicker label={props.label} invalidDateMessage="" emptyLabel=" "
                                inputVariant="outlined" format="dd.MM.yy HH:mm"
                                variant="inline" disableToolbar={true} autoOk={true} fullWidth={true}
                                value={props.value} onChange={(value) => props.setValue(value)}
        />
    );
};

DateTimePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    setValue: PropTypes.func.isRequired,
};

export default DateTimePicker;

